import React from 'react';

const SvgIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="350 350 380 370"
    height="24"
    width="24"
  >
    <g opacity="0.5">
      <path d="M540.1,707.1c-2.2,0-4.3-.8-5.8-2.3-1.2-1.1-6.2-4.9-11.5-8.8-27.9-20.7-93.1-69.3-125.8-120-9.8-13.3-17.6-27.1-23-41.1-10.7-22.5-9.5-48.4-9.2-52.1-.1-22.7,11.3-43.5,12.3-45.3h0c16-27.5,46.6-44,81.7-44s39.2,6.6,55.6,19.1c10.3,7.9,19.1,17.9,25.7,29.2,6.6-11.3,15.3-21.3,25.7-29.2,16.4-12.5,35.6-19.1,55.6-19.1,35.1,0,65.6,16.4,81.7,44h0c2.8,4.9,12.5,24.6,12.3,45.3.2,3.6,1.4,29.5-9.2,52.1-5.4,14-13.1,27.8-22.9,41.1-33.6,52.2-98.5,100-126.2,120.4-4.6,3.4-9.4,6.9-10.5,8-1.5,1.6-3.6,2.6-5.8,2.8-.2,0-.3,0-.5,0Z" />
      <path d="M621.3,402c31.7,0,59.4,14.2,74.3,39.8,0,0,11.4,20.1,11.1,41.2,0,0,2.1,26.3-8.5,48.5-4.6,11.9-11.5,25.3-22.2,39.7,0,0,0,0,0,0-40.9,63.6-131.6,122.2-136,127.4-8.4-7.9-96.9-66.5-136.1-127.4,0,0,0,0,0,0-10.6-14.4-17.6-27.8-22.2-39.7-10.6-22.2-8.5-48.5-8.5-48.5h0c-.2-21.1,11.1-41.2,11.1-41.2,14.9-25.6,42.6-39.8,74.3-39.8s69.8,26.3,81.3,60.1c11.6-33.8,43.6-60.1,81.3-60.1" />
    </g>
    <path
      fill="none"
      stroke="#000"
      strokeWidth="16"
      d="M621.3,402c31.7,0,59.4,14.2,74.3,39.8,0,0,11.4,20.1,11.1,41.2,0,0,2.1,26.3-8.5,48.5-4.6,11.9-11.5,25.3-22.2,39.7,0,0,0,0,0,0-40.9,63.6-131.6,122.2-136,127.4-8.4-7.9-96.9-66.5-136.1-127.4,0,0,0,0,0,0-10.6-14.4-17.6-27.8-22.2-39.7-10.6-22.2-8.5-48.5-8.5-48.5h0c-.2-21.1,11.1-41.2,11.1-41.2,14.9-25.6,42.6-39.8,74.3-39.8s69.8,26.3,81.3,60.1c11.6-33.8,43.6-60.1,81.3-60.1Z"
    />
  </svg>
);

export default SvgIcon;
